// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__12-US","error":"Textarea_error__Dx_dl","readonly":"Textarea_readonly__1Fmyu","disabled":"Textarea_disabled__1gHMf"};